
import Vue, { PropType } from 'vue'
import { Gateway } from '@/models'

import GatewayListHeader from './GatewayListHeader.vue'
import GatewayListItem from './GatewayListItem.vue'

export default Vue.extend({
  name: 'GatewayList',

  props: {
    gateways: Array as PropType<Array<Gateway>>,
  },

  components: {
    GatewayListHeader,
    GatewayListItem,
  },
})
